/**
 * Bootstrap JavaScript
 *
 * This file sets up global JavaScript utilities and configurations.
 */

import axios from 'axios';

// Make axios available globally
window.axios = axios;

// Set default headers
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Set up CSRF token for all requests
const token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

// Import error handler (dynamic import to avoid circular dependencies)
let errorHandlerPromise = null;

// Add response interceptor for global error handling
window.axios.interceptors.response.use(
    response => response,
    async error => {
        // Load error handler dynamically if not already loaded
        if (!errorHandlerPromise) {
            errorHandlerPromise = import('@/Composables/useErrorHandler.js');
        }

        try {
            const { useErrorHandler } = await errorHandlerPromise;
            const { handleAxiosError } = useErrorHandler();

            // Handle the error with user-friendly notifications
            // Set navigateToErrorPage to false for axios interceptor to avoid navigation loops
            // Individual components can still navigate by handling errors themselves
            // Set showToast to false to let individual components handle their own error display
            handleAxiosError(error, {
                showToast: false,
                navigateToErrorPage: false, // Don't auto-navigate from global interceptor
            });
        } catch (handlerError) {
            // Fallback if error handler fails to load
            console.error('Failed to load error handler:', handlerError);
            console.error('Original error:', error);
        }

        return Promise.reject(error);
    }
);
